<script>
  import { CipherStore } from "../store";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let currentCipher;

  let ciphers = [];

  CipherStore.subscribe(value => ciphers = value)

  function handleClick(cipherId) {
    dispatch('changeCipher', cipherId)
  }


</script>


<div class="table">
  {#each ciphers as cipher}
    {#if cipher.id == currentCipher}
      <button on:click={() => handleClick(cipher.id)} class='current'> {cipher.name} </button>
    {:else}
      <button on:click={() => handleClick(cipher.id)}> {cipher.name} </button>
    {/if}
  {/each}
</div>

<style>
  button {
    background: rgba(0,0,0,0);
    border: none;
    color: black;
    text-decoration: none;

    cursor: pointer;

    font-size: 2em;

    height: 2em;
  }

  .current {
    text-decoration: underline;
  }

  .table {
    display: flex;
    justify-content: center;

    flex-direction: column;

    text-align: center;

  }
</style>